
//ASSETS
import { Tooltip } from 'antd';
import area from '../../../../../../assets/img/card_area.svg';
import execucoes from '../../../../../../assets/img/card_execucao.svg';
import finalizados from '../../../../../../assets/img/card_talhao.svg';
import { transition_default } from '../../../../../../utils';

//STYLES
import { CardDetalhe } from "./components/card";
import { Detalhes } from "./style";

//PROPS
interface Props {
    dados_detalhamento: { 
        talhoes_finalizados:number, 
        qtd_talhoes:number, 
        qtd_execucoes:number, 
        qtd_planejadas:number, 
        area_concluida: string, 
        area_total: string 
    };
    setOpen_talhoes_finalizados: React.Dispatch<React.SetStateAction<boolean>>;
    setOpen_talhoes: React.Dispatch<React.SetStateAction<boolean>>;
    setOpen_execucoes: React.Dispatch<React.SetStateAction<boolean>>;
    setOpen_planejadas: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Detalhamento: React.FC<Props> = ({ dados_detalhamento, setOpen_talhoes_finalizados, setOpen_talhoes, 
    setOpen_execucoes, setOpen_planejadas
 }) => {

    const tooltip_area_concluida = `Considerando = Área do Talhão × (Soma das áeras concluídas ÷ quantidade de atividades).`;
    const tooltip_area_totaol = `Soma das áreas de todos os talhões`

    const detalhes = [
        {title: 'Talhões finalizados', value: dados_detalhamento?.talhoes_finalizados, icon: finalizados, type: 'number', titleSize: 12, tooltip: "", onClick: ()=>setOpen_talhoes_finalizados(true)},
        {title: 'Execuções', value: dados_detalhamento?.qtd_execucoes, icon: execucoes, type: 'number', titleSize: 12, tooltip: '', onClick: ()=>setOpen_execucoes(true)},
        {title: 'Área concluída', value: `${dados_detalhamento?.area_concluida} ha`, icon: area, type: 'area', titleSize: 12, tooltip: tooltip_area_concluida},
        {title: 'Qtde de Talhões', value: dados_detalhamento?.qtd_talhoes, icon: '', type: 'number', titleSize: 12, onClick: ()=>setOpen_talhoes(true)},
        {title: 'Atividades planejadas', value: dados_detalhamento?.qtd_planejadas, icon: '', type: 'number', titleSize: 10.5, onClick: ()=>setOpen_planejadas(true)},
        {title: 'Área Total', value: `${dados_detalhamento?.area_total} ha`, icon: '', type: 'area', titleSize: 12, tooltip: tooltip_area_totaol}
    ];

    return (
        <Detalhes
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            transition={{...transition_default, delay: 0.3}}
        >
            <p className="Detalhamento__title">Detalhamento</p>

            <div className="Detalhamento__cards">
                {(detalhes??[]).map(({title, value, type, icon, titleSize, tooltip, onClick}, i)=> {
                    return (
                        <Tooltip key={title+i} title={tooltip}>
                            <samp>
                            <CardDetalhe 
                                title={title}
                                value={value}
                                type={type}
                                icon={icon}
                                title_size={titleSize}
                                is_highlighted={i===0}
                                onClick={onClick}
                            />
                            </samp>
                        </Tooltip>
                    )
                })}
            </div>
        </Detalhes>
    )
}